import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import selectCourseCompare from './selectors';
import { actions } from './slice';
import { Course, CourseCompareState } from './types';

const useCourseCompare = (): {
    store: CourseCompareState;
    addCourse: (course: Course) => void;
    removeCourse: (course: Course) => void;
    clearCourses: () => void;
} => {
    const dispatch = useDispatch();
    const store = useSelector(selectCourseCompare);

    useEffect(() => {
        dispatch(actions.fetch());
    }, []);

    useEffect(() => {
        dispatch(actions.save());
    }, [store.courses]);

    const addCourse = (course: Course) => {
        if (!store.courses.some(storeCourse => storeCourse.id === course.id)) {
            dispatch(actions.add({ course }));
        }
    };
    const removeCourse = (course: Course) => dispatch(actions.remove({ course }));
    const clearCourses = () => dispatch(actions.clear());

    return { store, addCourse, removeCourse, clearCourses };
};

export default useCourseCompare;
